// Demo request resolver. While a demo is on screen (window.__demoMode), the
// network guard in src/utils/utils.js delegates here before falling back to its
// generic benign response. This lets the AI Conversation, Searches, Activity
// modals, and the AI Notes popover render rich sample data for the seeded
// /needs-review drafts — entirely client-side, no backend call.
//
// Importing this module registers the resolver on window. useDemoNetworkGuard
// imports it for its side effect, so the resolver is present whenever a demo
// page is mounted.
import {
  DEMO_THREADS,
  DEMO_ACTIVITY,
  DEMO_NOTES,
  DEMO_CONTACT_SEARCHES,
} from "./demoNeedsReviewData";

// "e:sarah@x.com" / "Sarah@X.com" -> "sarah@x.com"
function normEmail(v) {
  return String(v || "").replace(/^e:/i, "").trim().toLowerCase();
}

function emailFromBody(body) {
  if (!body) return "";
  return normEmail(
    body.contact_key || body.contact_email || body.email_search || body.email
  );
}

// Returns an axios-shaped { data } response for endpoints we serve in demo
// mode, or null to let the guard return its generic fallback.
export function resolveDemoRequest(url, body) {
  const u = String(url || "");
  const ends = (path) => u.endsWith(path) || u.includes(path + "?");

  if (ends("/ai-conversations/thread")) {
    const thread = DEMO_THREADS[emailFromBody(body)];
    return {
      data: thread
        ? { status: "success", ...thread }
        : { status: "success", ai_owns_relationship: true, contact: {}, pending_drafts: [], messages: [] },
    };
  }

  if (ends("/activity-explorer")) {
    const a = DEMO_ACTIVITY[emailFromBody(body)] || { email: [], platform: [] };
    return {
      data: {
        status: "success",
        data: a.email || [],
        platform_events: a.platform || [],
        total: (a.email || []).length,
        has_more: false,
      },
    };
  }

  if (ends("/agent-list-contact-handover-notes")) {
    return { data: { status: "success", notes: DEMO_NOTES[emailFromBody(body)] || [] } };
  }

  // The Searches modal embeds <PropertySearches> which fetches the full list
  // and filters client-side by the contact's email, so return everything.
  // (This endpoint returns the array directly as res.data, not res.data.items.)
  if (ends("/property-report-requests")) {
    return { data: DEMO_CONTACT_SEARCHES };
  }

  return null;
}

if (typeof window !== "undefined") {
  window.__demoResolver = resolveDemoRequest;
}
